<div class="container my-3 p-3 General container-fluid">
  <h3>{{'Welcome.SearchTitle'|translate}}</h3>
  <div class="row">
    <div class="col-sm-4" >
      <div >
        <a data-flickr-embed="true" href="https://www.flickr.com/photos/assessorprang/50354434687/in/album-72157689338128610/" title="thumbnail_DFA_1453-Edit"><img src="https://live.staticflickr.com/65535/50354434687_9cb92abe95_o.jpg" width="1024" height="1280" alt="thumbnail_DFA_1453-Edit"></a><script async src="//embedr.flickr.com/assets/client-code.js" charset="utf-8"></script>
      </div>

      <br><br>
      <!--<p>"{{'Welcome.Quote'|translate}}"-->

      <a href="https://www.flickr.com/photos/assessorprang/albums/72157689338128610" target="_blank">{{'MeetTheAssessor.officialheadshots'|translate}}</a><br>
      <a routerLink="/news-information/newsletters" >{{'Welcome.Subscribe'|translate}}</a><br>
      <a routerLink="/contact/requestspeaker" >{{'Welcome.RequestSpeaker'|translate}}</a><br>
      <a routerLink="/contact/requestcertificate" >{{'Welcome.RequestCertificateCommendation'|translate}}</a><br>
      <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1625694847/BIO/JPrang_BriefBiography.pdf" target="_blank">{{'MeetTheAssessor.Briefbio'|translate}}</a><br>
      <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1625694849/BIO/JPrang_Biography.pdf" target="_blank">{{'MeetTheAssessor.Fullbio'|translate}}</a><br><br><br>
    </div>

    <div class="col-sm-8">
      <h4>{{'Welcome.Welcome'|translate}}</h4>
      <p>{{'Welcome.ThisReal'|translate}}</p>
      <p>{{'Welcome.Additionally'|translate}}</p>
      <p [innerHTML]="'Welcome.TheOffice'|translate"></p>
      <!--
      <h4>{{'Welcome.AssessorPrang'|translate}}</h4>
      <p>{{'Welcome.LosAngeles'|translate}}</p>
      <p>{{'Welcome.Itsalsojustv2'|translate}}</p>
      <p>{{'Welcome.AssessorPrangis'|translate}}</p>
      <p>{{'Welcome.Upontaking'|translate}}</p>
      <p>{{'Welcome.TheLosAngelesv2'|translate}}</p>
      <p>{{'Welcome.AssessorPrangState'|translate}}</p>
      <p>{{'Welcome.AssessorJeff'|translate}}</p>
      -->
      <h4>{{'MeetTheAssessor.AssessorResponsibilities'|translate}}</h4>
      <b>{{'MeetTheAssessor.TheOffice2'|translate}}:</b>
      <ol>
        <li>{{'MeetTheAssessor.tolocate'|translate}}</li>
        <li>{{'MeetTheAssessor.toestablish'|translate}}</li>
        <li>{{'MeetTheAssessor.tocomplete'|translate}}</li>
        <li>{{'MeetTheAssessor.toapply'|translate}}</li>
      </ol>
    </div>
  </div>
</div>
